import { Component, OnInit } from "@angular/core"
import { UserService } from "../../services/user.service"
import { EduComponent } from "../../utils/eduComponent"
import Utils from "../../utils/utils"

@Component({
    selector: "app-simplified-footer",
    templateUrl: "./simplified-footer.component.html",
    styleUrls: ["./simplified-footer.component.scss"],
})
export class SimplifiedFooterComponent extends EduComponent implements OnInit {
    public gtmPrefix: string = "gtm-footer-"
    public isStudent: boolean
    public pbsLogoWhite
    public currentYear

    constructor(public userService: UserService) {
        super()
    }

    public ngOnInit() {
        this.isStudent = this.userService.hasStudentExperience()
        this.currentYear = Utils.getCurrentYear()
        this.pbsLogoWhite = require("../../../assets/PBS-logo-white.svg").default
    }
}
